import types from 'constants/ConstructionConstants';
import axios from 'axios';
import qs from 'qs';
import {getURL} from '../routes';

export function fetchConstructionDetailForReport(cid) {
  return axios.get(getURL("/api/construction/") + cid + '/cost?report=true')
}

export function fetchConstructionListAPI() {
  return axios.get(getURL("/api/construction"))
}

export function fetchConstructionDataAPI(cid) {
  return axios.get(getURL("/api/construction/") + cid)
}

export function updateConstructionAPI(cid, name, year, assignTo, status) {
  return axios.put(getURL("/api/construction/") + cid, 
                      qs.stringify({
                        'name': name,
                        'year': year,
                        'assignTo': assignTo,
                        'status': status
                      }))
}

export function addConstructionAPI(name, assignTo) {
  return axios.post(getURL("/api/construction"), 
                      qs.stringify({
                        'name': name,
                        'assignTo': assignTo
                      }))
}

export function deleteConstructionAPI(cid) {
  return axios.delete(getURL("/api/construction/") + cid)
}

export function fetchConstructionList() {
  return (dispatch) => {
    fetchConstructionListAPI()
      .then((response) => {
        let {constructionList} = response.data;
        dispatch(resetConstructionList(constructionList));
      })
      .catch((error) => {

      });
  }
}

export function trypUpdateConstruction(cid, name, year, assignTo, status, dismissModal) {
  return dispatch => {
    updateConstructionAPI(cid, name, year, assignTo, status)
      .then((response) => {
        if (response.data.success) {
          dispatch(updateConstruction(cid, name, year, assignTo, status))
        }
        dismissModal();
      })
      .catch((error) => {
        alert("修改失敗");
      })
  }
}

export function tryAddConstuction(name, year, assignTo, dismissModal) {
  return dispatch => {
    addConstructionAPI(name, assignTo)
      .then((response) => {
        let {cid} = response.data;
        
        if (cid > 0) {
          dispatch(addConstruction(cid, name, year, assignTo));
          dismissModal();
        } else {
          alert("新增失敗")
        }
      })
      .catch((error) => {
        alert("新增失敗")
      })
  }
}

export function tryDeleteConstruction(cid) {
  return dispatch => {
    deleteConstructionAPI(cid)
      .then((response) => {
        response.data.success
        ? dispatch(deleteConstruction(cid))
        : alert("删除失敗")          
      })
      .catch((error) => {
        alert("删除失敗")
      })
  }
}

export function resetConstructionList(constructionList) {
	return {
		type: types.RESET_CONSTRUCTION_LIST,
		constructionList,
	}
}

export function addConstruction(cid, name, year, assignTo) {
  return {
    type: types.ADD_CONSTRUCTION,
    cid, name, year, assignTo
  }
}

export function deleteConstruction(cid) {
  return {
    type: types.DELETE_CONSTRUCTION,
    cid
  }
}

export function updateConstruction(cid, name, year, assignTo, status) {
  return {
    type: types.UPDATE_CONSTRUCTION,
    cid, name, year, assignTo, status
  }
}


// WEBPACK FOOTER //
// ./src/actions/ConstructionActions.js